import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    selector: {
      width: 180,
      '& button': {
        textTransform: 'capitalize',
      },
      [BreakPointsMedia.SM]: {
        width: '100%',
      },
      [BreakPointsMedia.XS]: {
        width: '100%',
      },
      [BreakPointsMedia.XXS]: {
        width: '100%',
      },
    },
    selectorItem: {
      textTransform: 'capitalize',
    },
  },
  { name: 'TemplateCategoryFilter' },
);

export default useStyles;
